const translation = {
  title: 'Chú thích',
  name: 'Chú thích cho câu trả lời',
  editBy: 'Câu trả lời được chỉnh sửa bởi {{author}}',
  noData: {
    title: 'Không có chú thích',
    description: 'Bạn có thể chỉnh sửa chú thích trong phần gỡ lỗi ứng dụng hoặc nhập hàng loạt chú thích vào đây để có phản hồi chất lượng cao.',
  },
  table: {
    header: {
      question: 'câu hỏi',
      answer: 'câu trả lời',
      createdAt: 'tạo lúc',
      hits: 'lượt truy cập',
      actions: 'hành động',
      addAnnotation: 'Thêm chú thích',
      bulkImport: 'Nhập hàng loạt',
      bulkExport: 'Xuất hàng loạt',
      clearAll: 'Xóa tất cả chú thích',
    },
  },
  editModal: {
    title: 'Chỉnh sửa chú thích câu trả lời',
    queryName: 'Câu hỏi của người dùng',
    answerName: 'Câu trả lời của AI',
    yourAnswer: 'Câu trả lời của bạn',
    answerPlaceholder: 'Nhập câu trả lời của bạn vào đây',
    yourQuery: 'Câu hỏi của bạn',
    queryPlaceholder: 'Nhập câu hỏi của bạn ở đây',
    removeThisCache: 'Xóa chú thích này',
    createdAt: 'Được tạo lúc',
  },
  addModal: {
    title: 'Thêm chú thích câu trả lời',
    queryName: 'Câu hỏi',
    answerName: 'Câu trả lời',
    answerPlaceholder: 'Nhập câu trả lời vào đây',
    queryPlaceholder: 'Nhập câu hỏi ở đây',
    createNext: 'Thêm chú thích khác',
  },
  batchModal: {
    title: 'Nhập hàng loạt',
    csvUploadTitle: 'Kéo và thả tệp CSV của bạn vào đây hoặc ',
    browse: 'chọn tệp',
    tip: 'Tệp CSV phải tuân theo cấu trúc sau:',
    question: 'câu hỏi',
    answer: 'câu trả lời',
    contentTitle: 'tiêu đề nội dung',
    content: 'nội dung',
    template: 'Tải mẫu tại đây',
    cancel: 'Hủy',
    run: 'Chạy hàng loạt',
    runError: 'Chạy hàng loạt thất bại',
    processing: 'Đang xử lý hàng loạt',
    completed: 'Nhập hoàn tất',
    error: 'Lỗi khi nhập',
    ok: 'OK',
  },
  errorMessage: {
    answerRequired: 'Câu trả lời là bắt buộc',
    queryRequired: 'Câu hỏi là bắt buộc',
  },
  viewModal: {
    annotatedResponse: 'Câu trả lời đã chú thích',
    hitHistory: 'Lịch sử truy cập',
    hit: 'Lượt truy cập',
    hits: 'Lượt truy cập',
    noHitHistory: 'Không có lịch sử truy cập',
  },
  hitHistoryTable: {
    query: 'Câu hỏi',
    match: 'Độ chính xác',
    response: 'Phản hồi',
    source: 'Nguồn',
    score: 'Điểm',
    time: 'Thời gian',
  },
  initSetup: {
    title: 'Thiết lập ban đầu cho chú thích câu trả lời',
    configTitle: 'Thiết lập chú thích câu trả lời',
    confirmBtn: 'Lưu & Kích hoạt',
    configConfirmBtn: 'Lưu',
  },
  embeddingModelSwitchTip: 'Mô hình vector hóa văn bản chú thích, việc chuyển đổi mô hình sẽ dẫn đến việc nhúng lại, có thể phát sinh thêm chi phí.',
}

export default translation
